module.exports = __webpack_public_path__ + "group.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/group.svg?color1=%23333333&color2=
// module id = 2200
// module chunks = 67